import store from '@/store'

export default {
	methods: {
		percentage (n, total, c) {
			const pct = n * 100 / total
			return c ? pct.toFixed(c) : Math.round(pct)
		},
		average (array) {
			return array.reduce((sum, val) => {
				return sum + val
			}, 0) / array.length
		},
		humanNumber (n) {
			var parts = n.toString().split('.')
			parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ' ')
			if (store.getters.lang === 'fr') {
				return parts.join(',')
			}
			else {
				return parts.join('.')
			}
		}
	}
}



// WEBPACK FOOTER //
// ./src/mixins/numbers.js